import logo from './logo.svg';
import './App.css';
import { TodosList } from './TodosList';

function App() {
  return (
        <>
             <TodosList/>
        </>  
  );
}

export default App;
